import { Archive, PencilSimple, Tag } from '@phosphor-icons/react';

import { Button } from '../ui/Button';
import { cn } from '../../utils/cn';
import { formatCategoryLimitLabel } from '../../utils/categoryAllocation';
import pt from '../../locales/pt';

const BUCKET_ICON_TINT = {
  orphan: 'bg-warning-100 text-warning-800 dark:bg-warning-900/40 dark:text-warning-200',
  essential: 'bg-sage-100 text-sage-800 dark:bg-sage-900/50 dark:text-sage-200',
  lifestyle: 'bg-amber-100 text-amber-900 dark:bg-amber-950/50 dark:text-amber-200',
  personal_investment: 'bg-sky-100 text-sky-900 dark:bg-sky-950/50 dark:text-sky-200',
};

export function CategoryChip({
  category,
  bucketId = 'essential',
  isOrphan = false,
  dragHandle = null,
  onEdit,
  onArchive,
  className,
  style,
  setNodeRef,
}) {
  const limitLabel = isOrphan
    ? pt.categories.orphans.needsType
    : formatCategoryLimitLabel(category, pt);
  const tint = BUCKET_ICON_TINT[bucketId] || BUCKET_ICON_TINT.essential;
  const color = category.color || '#7C9E6F';

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        'box-border flex min-w-0 items-center gap-space-2 rounded-ds-md border border-border bg-card p-space-2',
        onEdit && 'cursor-pointer xl:cursor-default',
        isOrphan && 'border-dashed border-warning-500/50 bg-warning-50/60 dark:bg-warning-950/30',
        className,
      )}
      onClick={onEdit ? () => onEdit(category) : undefined}
    >
      {dragHandle}
      <span
        className={cn(
          'flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-ds-sm',
          isOrphan ? BUCKET_ICON_TINT.orphan : tint,
        )}
        style={
          !isOrphan && category.color
            ? { backgroundColor: `${color}33`, color }
            : undefined
        }
      >
        <Tag className="h-3.5 w-3.5" aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <p className="type-label truncate text-foreground">{category.name}</p>
        <p className="type-caption truncate tabular-nums text-muted-foreground">
          {limitLabel}
        </p>
      </div>
      {(onEdit || onArchive) && (
        <div className="hidden shrink-0 items-center xl:flex">
          {onEdit && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-[26px] w-[26px] px-0"
              aria-label={pt.categories.actions.edit}
              onClick={(e) => {
                e.stopPropagation();
                onEdit(category);
              }}
            >
              <PencilSimple className="h-3.5 w-3.5" aria-hidden />
            </Button>
          )}
          {onArchive && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-[26px] w-[26px] px-0"
              aria-label={pt.categories.actions.archive}
              onClick={(e) => {
                e.stopPropagation();
                onArchive(category);
              }}
            >
              <Archive className="h-3.5 w-3.5" aria-hidden />
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export { DragHandle as CategoryChipDragHandle } from '../common/DragHandle';
